import { render, staticRenderFns } from "./SlideUploaderComponent.vue?vue&type=template&id=3f8e8753&"
import script from "./SlideUploaderComponent.vue?vue&type=script&scoped=true&lang=js&"
export * from "./SlideUploaderComponent.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports